import { Space, Typography, Badge, Input } from "antd";
import { Footer } from "antd/es/layout/layout";
const { Text } = Typography;

export default function AppFooter() {
return (
<Footer
style={{
background: "#dbd8e8",
padding: "10px 24px",
display: "flex",
justifyContent:"space-between",
alignItems: "center",
borderTop: "1px solid #eee"
}}
> 
  <Space size="small">
    &copy; Copyright reserved.
  </Space>
</Footer>
);
}
